// extracted by mini-css-extract-plugin
export default {"container":"App_container__Cp8Z-","gridHeader":"App_gridHeader__a0ZE0","gridNavbar":"App_gridNavbar__ngH0b","gridMain":"App_gridMain__UVrWe","gridFooter":"App_gridFooter__fbscC"};